import _ from "lodash";

import UserApi from "@/api/userApi";
import StorageApi from "@/api/storageApi";
import MachineApi from "@/api/machinesApi";

export default {
  state: {
    usersList: [],
    usersListSelected: {},
    usersManageState: "",
    groupsList: [],
    isProfileUpdating: false
  },
  getters: {
    getUsersList(state) {
      return state.usersList;
    },
    getUsersListSelected(state) {
      return state.usersListSelected;
    },
    getUsersManageState(state) {
      return state.usersManageState;
    },
    getGroupsList: state => state.groupsList
  },
  actions: {
    isProfileUpdating({ state }, value) {
      state.isProfileUpdating = value;
    },
    resetList: ({ commit }) => {
      commit("RESET");
    },

    async setUsersList({ commit, rootGetters }) {
      const api = new UserApi(rootGetters["User/getUser"].OrganizationCode);

      // Get all users
      let users = [];
      const res = await api.getUsersList({ skip: 0, limit: 1 });
      users = res.result;
      if (res.total > res.result.length) {
        const res2 = await api.getUsersList({ skip: 1, limit: res.total });
        users = users.concat(res2.result);
      }
      commit("USERS_LIST", users);
    },

    async setGroupsList({ commit, rootGetters }) {
      const api = new MachineApi(rootGetters["User/getUser"].OrganizationCode);

      // SET Groups
      let groups = [];
      const res = await api.getGroups({ skip: 0, limit: 1 });
      groups = res.result;
      if (res.total > res.result.length) {
        const res2 = await api.getGroups({ skip: 1, limit: res.total });
        groups = groups.concat(res2.result);
      }

      commit("GROUPS_LIST", groups);
    },

    setUsersListSelected({ state, commit }, value) {
      const selected = _.filter(state.usersList, function (user) {
        return user.Id === value;
      });

      commit("USERS_LIST_SELECTED", !!selected.length === 1 ? selected[0] : {});
    },
    setUsersManageState({ commit }, value) {
      commit("USERS_MANAGE_STATE", value);
    },

    async addExternalUser({ rootGetters }, user) {
      const orgCode = rootGetters["User/getUser"].OrganizationCode;
      const userApi = new UserApi(orgCode);
      const storageApi = new StorageApi();

      const userAddExternal = {
        Language: user.Language,
        Firstname: user.Firstname,
        Lastname: user.Lastname,
        Username: user.Username,
        Email: user.Email,
        Role_Ids: user.Role_Ids,
        CreatorUserId: rootGetters["User/getUser"].ExternalUserId
      };

      const imgProfileAddUpd = user.myFile ? user.myFile.file : false;
      if (imgProfileAddUpd) {
        // Upload image Profile
        const res_upload = await storageApi.uploadFile(imgProfileAddUpd);
        userAddExternal.Image_Url = res_upload.link ? res_upload.link : "";
      }

      console.log("Add external user", userAddExternal);
      let resultUser = await userApi.saveExternalUser(userAddExternal);

      if (resultUser && resultUser.Id) {
        // Add machine groups
        await userApi.updateUserGroups(resultUser.Id, {
          Machine_Group_Ids: user.Machine_Group_Ids
        });
        resultUser.Machine_Group_Ids = user.Machine_Group_Ids;
      }
      if (resultUser.azureUuid) {
        resultUser = { ...resultUser, ...userAddExternal };
      }

      return resultUser;
    },

    async addUpdUser({ state, dispatch, rootGetters }, user) {
      const orgCode = rootGetters["User/getUser"].OrganizationCode;
      const userApi = new UserApi(orgCode);
      const storageApi = new StorageApi();

      let userAddUpd = {
        Username: user.Username,
        Language: user.Language,
        Firstname: user.Firstname,
        Lastname: user.Lastname
      };

      // NEW
      if (!user.Id) {
        userAddUpd.Email = user.Email;
      }

      const imgProfileAddUpd = user.myFile ? user.myFile.file : false;
      let emailUpd = false;

      // Eval Update Email if USER MNGE / PROFILE
      if (
        user.Id &&
        ((state.isProfileUpdating && rootGetters["User/getUser"].Email !== user.Email) ||
          (!state.isProfileUpdating &&
            rootGetters["UserManagement/getUsersListSelected"].Email !== user.Email))
      ) {
        emailUpd = user.Email;
      }

      try {
        if (imgProfileAddUpd) {
          //Upload image Profile
          const res_upload = await storageApi.uploadFile(imgProfileAddUpd);
          userAddUpd.Image_Url = res_upload.link ? res_upload.link : "";
        }

        // NEW
        if (!user.Id) {
          userAddUpd = await userApi.saveUser(userAddUpd);
        }
        // UPDATE
        else {
          // Update ME by User profile or with ID by User management
          await userApi.updateUser(user.Id, userAddUpd);
          userAddUpd.Id = user.Id;

          if (emailUpd) {
            try {
              await userApi.updateUserEmail(user.Id, {
                Email: emailUpd
              });
              userAddUpd.Email = emailUpd;
            } catch (e) {
              console.error(e);
              dispatch("Alert/Errors/setVal", { message: "Email already exist" }, { root: true });

              throw "Error on update email";
            }
          }
        }

        // ADD / UPD UPDATE FROM USER MANAGEMENT
        if (!state.isProfileUpdating) {
          // Update User Machine Groups
          try {
            await userApi.updateUserGroups(userAddUpd.Id, {
              Machine_Group_Ids: user.Machine_Group_Ids
            });
            userAddUpd.Machine_Group_Ids = user.Machine_Group_Ids;
          } catch (e) {
            throw "Error on updating user groups";
          }

          // Update User Roles
          // 15/4/2021 Maurizio: rimuovo l'aggiornamento dei ruoli
          /*
          try {
            const res_roles = await userApi.updateUserRoles(userAddUpd.Id, {
              Role_Ids: user.Role_Ids,
            });
            // Update user with labels
            userAddUpd.Role_Ids = user.Role_Ids;
          } catch (e) {
            throw 'Error on updating user roles';
          }
          */
        }

        const u = { ...user, ...userAddUpd };

        return u;
      } catch (e) {
        // Error on update user
        console.error(e);
        return null;
      }
    },

    updateListAfterEdit({ state, commit }, user) {
      // Delete if alredy in list in list
      const new_list = _.reject(state.usersList, item => {
        return item.Id === user.Id;
      });
      new_list.unshift(user);
      commit("USERS_LIST", new_list);
    },

    async deleteUser({ state, commit, rootGetters }, userId) {
      const api = new UserApi(rootGetters["User/getUser"].OrganizationCode);
      try {
        await api.deleteUser(userId);

        // Update list
        const new_list = _.reject(state.usersList, function (user) {
          return user.Id === userId;
        });
        commit("USERS_LIST", new_list);
        return true;
      } catch (e) {
        return false;
      }
    }
  },
  mutations: {
    USERS_LIST: (state, list) => {
      state.usersList = list;
    },
    USERS_LIST_SELECTED: (state, selected) => {
      state.usersListSelected = selected;
    },
    USERS_MANAGE_STATE: (state, value) => {
      state.usersManageState = value;
    },
    GROUPS_LIST: (state, payload) => {
      state.groupsList = payload;
    },
    RESET: state => {
      state.usersList = [];
      state.usersListSelected = {};
      state.usersManageState = "";
    }
  },
  namespaced: true
};
